(function () {
  const initSlider = (section) => {
    const slider = section.querySelector(".swiper--trust-icons");

    if (!slider || slider.swiper) return;

    const slides = slider.querySelectorAll(".trust-icons-card");

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    const nextBtn = slider.querySelector(".trust-icons-button--next");
    const prevBtn = slider.querySelector(".trust-icons-button--prev");
    const scrollbar = slider.querySelector(".swiper-scrollbar");
    const paginationEl = section.querySelector(".trust-icons__pagination");

    new Swiper(slider, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 16,
      speed: 800,
      mousewheel: {
        forceToAxis: true,
      },
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "trust-icons-button--disabled",
      },
      scrollbar: {
        el: scrollbar,
        grabCursor: true,
        draggable: true,
        hide: false,
      },
      breakpoints: {
        576: {
          spaceBetween: 20,
        },
      },
      pagination: {
        el: paginationEl,
        type: "bullets",
        clickable: true,
      },
    });
  };

  const destroySlider = (section) => {
    const slider = section.querySelector(".swiper--trust-icons");
    const slides = section.querySelectorAll(".trust-icons-card");

    if (slider?.swiper) slider.swiper.destroy();

    slides.forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove("swiper-slide");
    });
  };

  const initTrustIcons = (section) => {
    if (!section || !section?.classList.contains("trust-icons-section")) return;

    const box = section.querySelector(".trust-icons");

    if (!box) return;

    const hasMobileSlider =
      box.getAttribute("data-enable-mobile-slider") === "true";
    const hasDesktopSlider =
      box.getAttribute("data-enable-desktop-slider") === "true";

    const sectionResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 576 && hasMobileSlider) {
          initSlider(section);
        } else if (entry.contentRect.width >= 576 && hasDesktopSlider) {
          initSlider(section);
        } else {
          destroySlider(section);
        }
      });
    });

    sectionResizeObserver.observe(section);
  };

  initTrustIcons(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initTrustIcons(event.target);
  });
})();
